export default __webpack_public_path__ + "static/media/Intelligent-Quality.34221586.pdf";